import { Injectable } from '@angular/core';
import { getFirebaseBackend } from '../../authUtils';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { GlobalComponent } from "../../global-component";
import { ApiService } from '../services/api.service';

export interface User {
    id?: number;
    email?: string;
    username?: string;
    password?: string;
    firstName?: string;
    lastName?: string;
    token?: string;
}

const AUTH_API = GlobalComponent.AUTH_API;

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  

@Injectable({ providedIn: 'root' })

/**
 * Auth-service Component
 */
export class AuthenticationService {

    user!: User;
    currentUserValue: any;

    private currentUserSubject: BehaviorSubject<User>;
    // public currentUser: Observable<User>;

    constructor(private http: HttpClient, private api: ApiService) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')!));
        // this.currentUser = this.currentUserSubject.asObservable();
     }

    

 /**
     * Returns the current user
     */
    public currentUser(): any {
        return this.currentUserSubject.value;
    }
   

    /**
     * Logout the user
     */
    logout() {
        return this.api.logout().pipe(
            tap(() => {
                // sessionStorage.removeItem('currentUser');
                // sessionStorage.removeItem('token');
                localStorage.clear();
                this.currentUserSubject.next(null!);
            }),
            catchError((error: any) => {
                // sessionStorage.removeItem('currentUser');
                // sessionStorage.removeItem('token');
                localStorage.clear();
                this.currentUserSubject.next(null!);
                return of(undefined);
            })
        );

    }

    /**
     * Reset password
     * @param email email
     */
    resetPassword(email: string) {
        return getFirebaseBackend()!.forgetPassword(email).then((response: any) => {
            const message = response.data;
            return message;
        });
    }

}

